import "@/App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import DriverStatus from "@/sections/DriverStatus";
import Reviews from "@/sections/Reviews";
import PromiseBar from "@/sections/PromiseBar";
import Services from "@/sections/Services";
import Areas from "@/sections/Areas";
import HowItWorks from "@/sections/HowItWorks";
import FAQ from "@/sections/FAQ";
import Booking from "@/sections/Booking";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import FloatingCTAs from "@/sections/FloatingCTAs";
import MobileStickyBar from "@/sections/MobileStickyBar";
import CookieBanner from "@/components/CookieBanner";
import PolicyBar from "@/components/PolicyBar";
import MaintenanceOverlay from "@/components/MaintenanceOverlay";
import AdminAnalytics from "@/pages/AdminAnalytics";
import { LanguageProvider } from "@/i18n/LanguageContext";

function MainSite() {
  return (
    <div className="App bg-white text-[#0A0A0A] dark:bg-[#0A0A0A] dark:text-white">
      <PolicyBar />
      <Header />
      <main>
        <Hero />
        <DriverStatus />
        <Reviews />
        <Areas />
        <HowItWorks />
        <PromiseBar />
        <Services />
        <FAQ />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <FloatingCTAs />
      <MobileStickyBar />
      <CookieBanner />
      <MaintenanceOverlay />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminAnalytics />} />
          <Route path="*" element={<MainSite />} />
        </Routes>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: { fontFamily: "Manrope, sans-serif" },
          }}
        />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
